/*
Тип режима синхронизации графиков
*/
export enum DiagramSyncModeType {
  ZoomX = 'zoomX',
  Cursors = 'cursors',
  TimeIntervals = 'timeIntervals',
}
